export enum SystemRole {
	ADMIN = 'Super admin',
	TAC = 'TAC',
	MC = 'MC',
	ES = 'ES',
	EXPERT = 'Expert',
	BOARD_MEMBER = 'Board member',
	DIRECTOR = 'Director',
}

const systemRoleDisplayNames: Partial<Record<SystemRole, string>> = {
	[SystemRole.DIRECTOR]: 'ASD-STAN Admin',
};

export const getSystemRoleLabel = (role: SystemRole | string): string =>
	systemRoleDisplayNames[role as SystemRole] ?? role;
